import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=a577cf02&"
import script from "./productDetails.vue?vue&type=script&lang=ts&"
export * from "./productDetails.vue?vue&type=script&lang=ts&"
import style0 from "./productDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports